import { getDate } from "../utils/date.utils";
/** @type {Record<string, any[]>} */
let registry = {};

/**
 * @param {string} onHook
 * @param {string} name
 * @param {() => {}} cb
 */
export const registerHookScript = (onHook, name, cb) => {
    if (!registry[onHook]) {
        registry[onHook] = [];
    }
    const existing = registry[onHook].filter((s) => s.name === name);
    if (existing.length) {
        console.log(getDate(), `Script ${name} already exists on hook ${onHook}`);
        return;
    }
    registry[onHook].push({ name, cb });
};

/** @typedef {({status: "rejected", reason: string} | {status: "fulfilled", value: any})} SettledResult */
/**
 * @param {string} hook
 * @param {any} args
 */
export const runHook = async (hook, args) => {
    try {
        if (registry[hook] && registry[hook].length) {
            /** @type {SettledResult[]} */
            const promiseResults = await Promise.allSettled(registry[hook].map((script) => script.cb(args)));

            // Find any rejected and log them
            promiseResults.forEach((pr, index) => {
                if (pr.status === "rejected") {
                    /** @type {string} */
                    const name = registry[hook][index].name;
                    console.log(`Hook script "${name}" on hook "${hook}" failed with`, pr.reason);
                }
            });
        }
    } catch (e) {
        console.log(getDate(), `Executing hook scripts for hook "${hook}" failed: ${e.message}`);
    }
};
